import { AnyAction } from 'redux';
import { STRATEGY_ACTIONS } from '../actions/index';
import { StrategyState } from '../types/state';

import produce from 'immer';

const initialState: StrategyState = {
  isLoading: false,
  selectedCard: 0,
  selectedProperty: undefined,
  selectedMarket: undefined,
  data: undefined,
  autoApprove: undefined,
};

const strategyReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case STRATEGY_ACTIONS.LOADING: {
      return produce(state, (dft) => {
        dft.isLoading = action.payload;
      });
    }

    case STRATEGY_ACTIONS.SET_CARD: {
      return produce(state, (dft) => {
        dft.selectedCard = action.payload;
      });
    }

    case STRATEGY_ACTIONS.SET_SELECTED_PROPERTY: {
      return produce(state, (dft) => {
        dft.selectedProperty = String(action.payload);
      });
    }
    case STRATEGY_ACTIONS.SET_SELECTED_MARKET: {
      return produce(state, (dft) => {
        dft.selectedMarket = String(action.payload);
      });
    }

    case STRATEGY_ACTIONS.FETCH_AUTO_APPROVE:
    case STRATEGY_ACTIONS.UPDATE_AUTO_APPROVE: {
      return produce(state, (dft) => {
        dft.autoApprove = action.payload;
      });
    }

    case STRATEGY_ACTIONS.SAVED: {
      return produce(state, (dft) => {
        if (state.selectedCard !== undefined) {
          dft.data.cards[state.selectedCard].state = 'saved';
          dft.data.cards[state.selectedCard].active =
            dft.data.cards[state.selectedCard].selected;
        }
      });
    }

    case STRATEGY_ACTIONS.NOT_SAVED: {
      return produce(state, (dft) => {
        if (state.selectedCard !== undefined) {
          dft.data.cards[state.selectedCard].state = 'initial';
        }
      });
    }

    case STRATEGY_ACTIONS.SET_STRATEGY: {
      return produce(state, (dft) => {
        if (state.selectedCard !== undefined) {
          dft.data.cards[state.selectedCard].selected = action.payload;
          dft.data.cards[state.selectedCard].state = 'toSave';
        }
      });
    }
    case STRATEGY_ACTIONS.FETCH_DATA: {
      return produce(state, (dft) => {
        dft.data = action.payload;
        //dft.selectedCard = 0;
      });
    }
    default:
      return state;
  }
};

export default strategyReducer;
